import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';
import { SimpleTask } from '../components/TaskList';

interface TaskDetailsModalContextType {
  showModal: boolean;
  modalTask: SimpleTask | null;
  openModal: (task: SimpleTask) => void;
  closeModal: () => void;
}

const TaskDetailsModalContext = createContext<TaskDetailsModalContextType | undefined>(undefined);

export const useTaskDetailsModal = () => {
  const context = useContext(TaskDetailsModalContext);
  if (!context) {
    throw new Error('useTaskDetailsModal must be used within a TaskDetailsModalProvider');
  }
  return context;
};

interface TaskDetailsModalProviderProps {
  children: ReactNode;
}

export const TaskDetailsModalProvider: React.FC<TaskDetailsModalProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalTask, setModalTask] = useState<SimpleTask | null>(null);

  const openModal = useCallback((task: SimpleTask) => {
    setModalTask(task);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setModalTask(null);
  }, []);

  const value = useMemo(() => ({ showModal, modalTask, openModal, closeModal }), [showModal, modalTask, openModal, closeModal]);

  return (
    <TaskDetailsModalContext.Provider value={value}>
      {children}
    </TaskDetailsModalContext.Provider>
  );
};